<template>
  <main>
    <v-card-title class="dialog-header ">{{ formTitle }}</v-card-title>
    <v-card-text>
      <v-form @submit.prevent="$emit('on_submit_form')">
        <form-wrapper :validator="v.form">
          <v-container>
            <v-row>
              <v-col cols="12" v-if="isEdit">
                <locale-select @change="$emit('change_locale', $event)" />
              </v-col>
              <v-col cols="12" md="6">
                <form-group name="name">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.name"
                      outlined
                    ></v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12" md="6">
                <form-group name="sub_name" attribute="fields.sub_name">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.sub_name"
                      outlined
                    ></v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12" md="6">
                <form-group name="price" attribute="label.price">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      no-wheel
                      type="number"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.price"
                      outlined
                    ></v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12" md="6">
                <form-group name="duration" attribute="label.duration">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      no-wheel
                      type="number"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.duration"
                      outlined
                    ></v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12">
                <form-group name="description" attribute="label.description">
                  <template slot-scope="{ attrs, listeners }">
                    <v-textarea
                      no-wheel
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.description"
                      rows="7"
                      outlined
                      no-resize
                    ></v-textarea>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12">
                <form-group name="notes" attribute="label.notes">
                  <template slot-scope="{ attrs, listeners }">
                    <v-textarea
                      no-wheel
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.notes"
                      rows="7"
                      outlined
                      no-resize
                    ></v-textarea>
                  </template>
                </form-group>
              </v-col>
              <v-col>
                <v-color-picker
                  mode="hexa"
                  hide-mode-switch
                  v-model="form.color"
               
                ></v-color-picker>
              </v-col>
              <v-col cols="12">
                <v-btn
                  class="primary"
                  type="submit"
                  :loading="loading"
                  :disabled="v.form.$invalid"
                  block
                  >{{ $t("button.submit") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </form-wrapper>
      </v-form>
    </v-card-text>
  </main>
</template>
<script>
export default {
  name: "FormActions",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    v: {
      type: Object,
      default: () => {},
    },

    form: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    formTitle() {
      if (!this.isEdit) {
        return this.$t("heading.create");
      } else {
        return this.$t("heading.edit");
      }
    },
  },
};
</script>
